import { isPartRejected } from '../helpers/pollRework';
import { TCompositePollDetails } from '../types/pollsSchema';
import { shuffleArray } from './mappedSingleTestData';

export const mappedCompositeTestData = (data: TCompositePollDetails) => {
  const result = {
    ...data,
    composite: data.composite.map(item => {
      const sourceImages = Array.isArray(item.images) ? item.images : [];
      const resultImages = item.images_show_random
        ? shuffleArray([...sourceImages])
        : [...sourceImages];
      return {
        ...item,
        images: resultImages.map(img => ({
          ...img,
          isBlurred:
            item.type === 'click' ||
            item.media_type === 'text' ||
            sourceImages[0]?.type === 'text' ||
            isPartRejected(item)
              ? false
              : true,
          isAdultOnly: data.adult_only,
        })),
      };
    }),
  };
  return result;
};
